if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position ?? 0;
        return this.substr(position, searchString.length) === searchString;
    };
}
export class Command {
    _method;
    _url;
    _resultDataType;
    constructor(method, url) {
        this._method = method;
        this._url = url;
        this._resultDataType = null;
    }
    get method() {
        return this._method;
    }
    get url() {
        return this._url;
    }
    configure = null;
}
